import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

import ProfileSettings from "../components/Settings/ProfileSettings";
import PasswordSettings from "../components/Settings/PasswordSettings";
import LicensesSettings from "../components/Settings/LicensesSettings";

Vue.use(VueRouter);
const routes = [{
    path: "/",
    name: "home",
    meta: {
      layout: 'main'
    },
    component: Home
  },
  {
    path: "/signup/:platform/:plan/:step",
    name: "signup",
    meta: {
      layout: 'signup'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( "../views/Signup.vue")
  },
  {
    path: "/promo/:step",
    name: "promo",
    meta: {
      layout: 'signup'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import( "../views/Promo.vue")
  },
  {
    path: "/policies/:policy",
    name: "policies",
    meta: {
      layout: 'policy'
    },
    component: () => import( /*webpackChunkName:"policy"*/ "../views/Policy.vue")
  },
  {
    path: "/security/",
    name: "security",
    meta: {
      layout: 'main'
    },
    component: () => import( /*webpackChunkName:"policy"*/ "../views/Security.vue")
  },
  {
    path: "/pricing/",
    name: "pricing",
    meta: {
      layout: 'main'
    },
    component: () => import( /*webpackChunkName:"policy"*/ "../views/Pricing.vue")
  },
  {
    path: "/support/",
    name: "support",
    meta: {
      layout: 'main'
    },
    component: () => import( /*webpackChunkName:"policy"*/ "../views/Support.vue")
  },
  {
    path: "/settings/profile",
    component: ProfileSettings
  },
  {
    path: "/settings/password",
    component: PasswordSettings
  },
  {
    path: "/settings/licenses",
    component: LicensesSettings
  }
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
export default router;